import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import moment from "moment";


import * as commonFunc from 'scripts/common';

import {
    Label, Badge, Col
} from "reactstrap";


export default function TextViewFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue } = formManager;//errors, control

    const [shouldRender, setShouldRender] = React.useState(false);
    const [badgeCss, setBadgeCss] = React.useState("");
    const [customBg, setCustomBg] = React.useState("");

    React.useEffect(() => {
        if (data.subType === "badge") {
            if (data.isInfluencedBy) {
                modelFctManager.onActionRequired(data.name, { trigger: "findFragment", target: data.isInfluencedBy, value: "" }, data).then((response) => {
                    if (response.isSuccess && response.result) {
                        var css = response.result.defaultValue;
                        if (!commonFunc.isBlank(css)) {
                            setBadgeCss(css.replace(/label-/g, "bg-").replace(/label/g, "badge").replace("bg-default", "bg-secondary").replace("fa-", "untrigger"));
                        }
                    }
                });
            }
            else {
                setBadgeCss(data.argumentsObj?.badgeCss || "");
            }
        }
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, args.trigger === "setValue" ? { value: (data.hasOwnProperty("defaultValue") ? data.defaultValue : "") } : null).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.refreshFromCache = (value, withRerender, src) => {
        return new Promise((resolve, reject) => {
            if (data.onActionEvents && data.onActionEvents["onRefresh"]) {
                data.onActionEvents["onRefresh"].forEach((args, index) => {
                    modelFctManager.onActionRequired(data.name, args, data, { value: value }).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }
            resolve({ isSuccess: true, result: value });
        });
    };
    data.functionManager.setValue = (value, withRerender, src) => {
        return new Promise((resolve, reject) => {
            var newValue = (!data.argumentsObj?.manageUtc || (value?.endsWith && value?.endsWith("Z"))) ? value : (value + "Z");
            if (!commonFunc.isBlank(data.format) && data.format.startsWith("date:") && value) {
                var altFormat = data.format.replace("date:", "");
                newValue = moment(value).format(altFormat);
            }
            setValue(bindPropResult, newValue);
            if (withRerender) setShouldRender(!shouldRender);

            if (data.onActionEvents && data.onActionEvents["onChange"]) {
                data.onActionEvents["onChange"].forEach((args, index) => {
                    modelFctManager.onActionRequired(data.name, args, data, { value: value }).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }

            resolve({ isSuccess: true, result: value });
        });
    };
    data.functionManager.setBackground = (value, withRerender, src) => {
        return new Promise((resolve, reject) => {
            setCustomBg(modelFctManager.getRgbaFromHex(value));

            resolve({ isSuccess: true, result: value });
        });
    };


    register(bindPropResult, {
        value: (data.hasOwnProperty("defaultValue") ? data.defaultValue : ""),
        valueAsNumber: (data.subType === "integer" || data.subType === "float")
    });

    var frameClass = "d-inline-block mb-3";
    var frameStyle = {};
    var containerClass = "";

    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "form-group m-0 ";
    var formStyle = {};

    var icon = "";
    var titleClass = "text-start ";
    var titleStyle = {};

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_textview");
    data.mergedDesign = design;
    if (design) {
        if (design.alignment) {
            var split = design.alignment.split("|");
            split.forEach((part) => {
                frameClass += " text-" + part.replace("left", "start").replace("right", "end");
                frameClass = frameClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
                if (part === "center" && design.alignment.indexOf("top") < 0 && design.alignment.indexOf("bottom") < 0) frameClass += " align-self-center";
                containerClass += " justify-content-" + part.replace("left", "start").replace("right", "end");
            });
        }
        if (design.boxSize) {
            //frameClass += " w-" + parseInt(parseFloat(design.boxSize) * 100);
            //titleClass += " w-100";
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            titleClass += modelFctManager.convertWidthToGrid(100);
        }
        if (design.size || design.width) frameStyle.width = (design.size ? (design.size + "px") : design.width);
        /*if (design.size || design.width) {
            if (parseFloat(design.width.replace("px", "")) >= 0) frameStyle.width = design.width;
            //else {
            //    frameClass += " w-100";
            //}
        }*/
        if (design.maxWidth) frameStyle.maxWidth = design.maxWidth;
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) {
                //TEMP : Gestion décalage px/dp Android pour Home
                if (parentProps?.parentData?.groupSubName === "containerGroup" || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.groupSubName === "containerGroup") {
                    frameStyle.height = (parseFloat(design.height.replace("px", "")) * 2) + "px";
                }
                else {
                    frameStyle.height = design.height;
                }
            }
            else {
                frameClass += " h-100";
            }
        }

        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        //Object.assign(frameStyle, modelFctManager.managePadding(design, frameClass));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));
        if (design.margin) frameClass = frameClass.replace("mb-3", "");
        if (design.marginBottom) frameClass = frameClass.replace("mb-3", "");
    }

    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_textviewTitle", true);
    if (designTitle) {
        if (designTitle.alignment) {
            titleClass = titleClass.replace("text-start", "");
            var splitT = designTitle.alignment.split("|");
            splitT.forEach((part) => {
                titleClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleClass = titleClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
        if (designTitle.boxSize) {
            //titleWidthClass += " w-" + parseInt(parseFloat(designTitle.boxSize) * 100);
            titleClass = titleClass.replace(modelFctManager.convertWidthToGrid(100), "");
            titleClass += designTitle.boxSize === "auto" ? " col-auto" : modelFctManager.convertWidthToGrid(parseFloat(designTitle.boxSize) * 100);
        }

        Object.assign(titleStyle, modelFctManager.setCustomBackground(designTitle, data));
        Object.assign(titleStyle, modelFctManager.managePadding(designTitle, titleClass));
        Object.assign(titleStyle, modelFctManager.manageMargin(designTitle, titleClass));
        if (designTitle.margin) titleClass = titleClass.replace("mb-0", "");
        if (designTitle.marginBottom) titleClass = titleClass.replace("mb-0", "");

        if (designTitle.fontColor) titleStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleStyle.fontStyle = "italic";
        }
    }
    var designIcon = data.customDesign?.designIcon;
    designIcon = modelFctManager.prepareMergedDesign(data, designIcon, "default_textviewIcon", true);
    if (designIcon) {
        var iconStyle = {};

        Object.assign(iconStyle, modelFctManager.setCustomBackground(designIcon, data));
        Object.assign(iconStyle, modelFctManager.managePadding(designIcon, ""));
        Object.assign(iconStyle, modelFctManager.manageMargin(designIcon, ""));


        if (designIcon.fontColor) iconStyle.color = modelFctManager.getRgbaFromHex(designIcon.fontColor);
        if (designIcon.fontSize) iconStyle.fontSize = designIcon.fontSize;
        if (designIcon.fontStyle) {
            if (designIcon.fontStyle.indexOf("bold") >= 0) iconStyle.fontWeight = "bold";
            if (designIcon.fontStyle.indexOf("italic") >= 0) iconStyle.fontStyle = "italic";
        }

        //TODO : alignment
        if (designIcon.alignment) {
            switch (designIcon.alignment) {
                case "end":
                case "right":
                    //iconStyle. = "";
                    break;
                case "center":
                    formStyle.justifySelf = "center";
                    break;
                default:
                    break;
            }
        }

        if (designIcon.icon) icon = <i className={`fa ${designIcon.icon.replace(/_/g, "-")}`} style={iconStyle} data-backimage={iconStyle.hasImage || null} data-imageopacity={iconStyle.alpha || null}></i>
    }
    var dividerStyle = {};
    var designInput = data.customDesign?.designInput;
    designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_textviewInput", true);
    if (designInput) {
        if (designInput.backColor) dividerStyle.color = modelFctManager.getRgbaFromHex(designInput.backColor);
        if (designInput.height) dividerStyle.borderTop = designInput.height + (data.subType === "divider-dashed" ? " dashed " : " solid ") + (designInput.backColor ? modelFctManager.getRgbaFromHex(designInput.backColor) : "");
    }




    if (!commonFunc.isBlank(titleClass)) containerClass += " row m-0 row-cols-lg-auto2 align-items-center";

    titleStyle.backgroundColor = customBg || titleStyle.backgroundColor;


    var defaultVal = data.defaultValue;
    defaultVal = bindPropResult ? (getValues(bindPropResult) || data.defaultValue) : defaultVal;
    if (!commonFunc.isBlank(data.format) && data.format.startsWith("date:") && data.defaultValue) {
        var altFormat = data.format.replace("date:", "");
        var displayValue = (!data.argumentsObj?.manageUtc || (data.defaultValue?.endsWith && data.defaultValue.endsWith("Z"))) ? data.defaultValue : (data.defaultValue + "Z");
        defaultVal = moment(displayValue).format(altFormat);
    }
    var title = (defaultVal != null && defaultVal !== undefined && defaultVal !== "") ? defaultVal.toString() : data.title;

    data.childCount = data.children ? data.children.length : 0;
    var childs = data.children?.map((child) => { return modelFctManager.componentTyped(child, { ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false), stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup")) }); }) || "";

    var baseForm = "";
    if (data.subType === "badge") {
        baseForm = <div className={`${containerClass} ${formClass}`} style={formStyle}>
            {altT(data.title)}
            <Badge color={titleStyle.backgroundColor || !commonFunc.isBlank(badgeCss) ? "" : "secondary"} className={`${titleClass} ${badgeCss} m-0 ms-1`} title={altT(data.title) + altT(defaultVal)} style={titleStyle} data-backimage={titleStyle.hasImage || null} data-imageopacity={titleStyle.alpha || null}>{icon}{altT(defaultVal)}</Badge>
            {childs}
        </div>;
    }
    else {
        if (commonFunc.isBlank(altT(title)) && (!data.subType || !data.subType.startsWith || !data.subType.startsWith("divider"))) {
            //frameClass = frameClass.replace("d-inline-block", "");
            baseForm = <div className={`${containerClass.replace("row", "")} ${formClass}`} style={formStyle}>
                {icon}
                {childs}
            </div>;
        }
        else {
            baseForm = <div className={`${containerClass} ${formClass}`} style={formStyle}>
                <Label className={`${titleClass} mb-0`} style={titleStyle} data-backimage={titleStyle.hasImage || null} data-imageopacity={titleStyle.alpha || null}>{altT(title)}</Label>
                {data.subType === "divider" ? <hr className="hr-line-solid mb-0" style={dividerStyle} /> : ""}
                {data.subType === "divider-dashed" ? <hr className="hr-line-dashed mb-0" style={dividerStyle} /> : ""}
                {icon}
                {childs}
            </div>;
        }
    }

    //console.debug("render textview");

    return <Col data-name="TextViewFrag" data-element={data.objType} xs="auto" className={`${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>{baseForm}</Col>;//align-self-center
}